module.exports = __webpack_public_path__ + "img/3_l.addfbc14.jpg";